import { createSlice } from "@reduxjs/toolkit";
import { DemandaSliceInterface } from "interfaces/demandas/demandasInterface";

export const demandaSlice = createSlice({
  name: "demanda",
  initialState: {
    lstRegiones: [],
    lstOficialias: [],
    lstMaterias: [],
    lstInstancias: [],
    lstVias: [],
    lstJuicios: [],
    capturaPartesDemandados: [],
    capturaPartesActores: [],
    listUploaddedFiles: [],
    file: null,
    solicitudDemandaRes: null,
    formNotas: null,
    formSolicitudDemanda: null,
    cveRegion: null,
    cveOficialia: null,
    cveMateria: null,
    cveInstancia: null,
    cveVia: null,
    cveJuicio: null,
    tipoModalidad: true,
    completeStepOne: false,
    showModalVisor: false,
    documentSelected: "",
    stepDemanda: 0,
    solicitudesDemandas: [],
    solicitudesDemandasLaborales: [],
    initialCapturaParteActores: [],
    initialCapturaParteDemandados: [],
    solicitudDemandaDocumentos: [],
    successMoveSolicitudToDemanda: false,
    solicitudDemandaSelected: null,
    modalPermisoLiti: false,
  } as DemandaSliceInterface,
  reducers: {
    onAddRegiones: (state, { payload }) => {
      state.lstRegiones = payload;
    },
    onAddRegionId: (state, { payload }) => {
      state.cveRegion = payload;
    },
    onAddOficialiaId: (state, { payload }) => {
      state.cveOficialia = payload;
    },
    onAddMateriaId: (state, { payload }) => {
      state.cveMateria = payload;
    },
    onAddInstanciaId: (state, { payload }) => {
      state.cveInstancia = payload;
    },
    onAddViaId: (state, { payload }) => {
      state.cveVia = payload;
    },
    onAddJuicioId: (state, { payload }) => {
      state.cveJuicio = payload;
    },
    onAddOficialias: (state, { payload }) => {
      state.lstOficialias = payload;
    },
    onAddMaterias: (state, { payload }) => {
      state.lstMaterias = payload;
    },
    onAddInstancias: (state, { payload }) => {
      state.lstInstancias = payload;
    },
    onAddVias: (state, { payload }) => {
      state.lstVias = payload;
    },
    onAddJuicios: (state, { payload }) => {
      state.lstJuicios = payload;
    },
    onPermisoJuicios: (state, { payload }) => {
      state.modalPermisoLiti = payload;
    },
    onChangeTipoModalidad: (state) => {
      state.tipoModalidad = !state.tipoModalidad;
    },
    onAddTipoModalidad: (state, {payload}) => {
      state.tipoModalidad = payload;
    },
    onAddStepDemanda: (state, { payload }) => {
      state.stepDemanda = payload;
    },
    onSolicitudesDemandas: (state, { payload }) => {
      state.solicitudesDemandas = payload;
    },
    onAddCapturaPartesActores: (state, { payload }) => {
      state.capturaPartesActores = payload;
    },
    onAddFormNotas: (state, { payload }) => {
      state.formNotas = payload;
    },
    onAddFormSolicitudDemandas: (state, { payload }) => {
      state.formSolicitudDemanda = payload;
    },
    onAddCapturaPartesDemandados: (state, { payload }) => {
      state.capturaPartesDemandados = payload;
    },
    onSolicitudesDemandasLaborales: (state, { payload }) => {
      state.solicitudesDemandasLaborales = payload;
    },
    onCompleteStepOne: (state) => {
      state.completeStepOne = !state.completeStepOne;
    },
    onAddFileStep: (state, { payload }) => {
      state.file = payload;
    },
    onAddSolicitudDemandaRes: (state, { payload }) => {
      state.solicitudDemandaRes = payload;
    },
    onAddListUploaddedFiles: (state, { payload }) => {
      state.listUploaddedFiles = payload;
      state.file = null;
    },
    onShowModalVisor: (state, { payload }) => {
      state.showModalVisor = payload;
    },
    onAddDocumentSelected: (state, { payload }) => {
      state.documentSelected = payload;
    },
    onSuccessMoveSolcitudToDemanda: (state, { payload }) => {
      state.successMoveSolicitudToDemanda = payload;
    },
    onAddSolicitudDemandaSelected: (state, { payload }) => {
      state.solicitudDemandaSelected = payload;
    },
    onAddInitialActoresPartes: (state, { payload }) => {
      state.initialCapturaParteActores = payload;
    },
    onAddInitialDemandadosPartes: (state, { payload }) => {
      state.initialCapturaParteDemandados = payload;
    },
    onAddDocumentosListDemanda: (state, { payload }) => {
      state.solicitudDemandaDocumentos = payload;
    },
    onUpdateListSolicitudDemanda: (state, { payload }) => {
      state.solicitudesDemandas = state.solicitudesDemandas.filter(
        (solicitud) => solicitud.idSolicitudDemanda !== payload
      );
    },
    onResetSelectsDemanda: (state) => {
      state.lstOficialias = [];
      state.lstMaterias = [];
      state.lstInstancias = [];
      state.lstVias = [];
      state.lstJuicios = [];
      state.cveRegion = null;
      state.cveOficialia = null;
      state.cveMateria = null;
      state.cveInstancia = null;
      state.cveVia = null;
      state.cveJuicio = null;
      state.modalPermisoLiti = false;
    },
    onAllResetStateDemandas: (state) => {
      state.lstRegiones = [];
      state.lstOficialias = [];
      state.lstMaterias = [];
      state.lstInstancias = [];
      state.lstVias = [];
      state.lstJuicios = [];
      state.capturaPartesDemandados = [];
      state.capturaPartesActores = [];
      state.listUploaddedFiles = [];
      state.file = null;
      state.solicitudDemandaRes = null;
      state.formNotas = null;
      state.formSolicitudDemanda = null;
      state.cveRegion = null;
      state.cveOficialia = null;
      state.cveMateria = null;
      state.cveInstancia = null;
      state.cveVia = null;
      state.cveJuicio = null;
      state.tipoModalidad = true;
      state.completeStepOne = false;
      state.showModalVisor = false;
      state.documentSelected = "";
      state.stepDemanda = 0;
      state.solicitudesDemandas = [];
      state.solicitudesDemandasLaborales = [];
      state.initialCapturaParteActores = [];
      state.initialCapturaParteDemandados = [];
      state.solicitudDemandaDocumentos = [];
      state.successMoveSolicitudToDemanda = false;
      state.solicitudDemandaSelected = null;
      state.modalPermisoLiti = false;
    },
  },
});

//actions creators are generated for each case reducer function
export const {
  onSolicitudesDemandas,
  onSolicitudesDemandasLaborales,
  onAddRegiones,
  onAddOficialias,
  onAddMaterias,
  onAddInstancias,
  onAddVias,
  onChangeTipoModalidad,
  onAddJuicios,
  onAddRegionId,
  onAddOficialiaId,
  onAddMateriaId,
  onAddInstanciaId,
  onAddViaId,
  onAddJuicioId,
  onAddStepDemanda,
  onAddFormNotas,
  onAddFormSolicitudDemandas,
  onAddCapturaPartesActores,
  onAddCapturaPartesDemandados,
  onCompleteStepOne,
  onAddFileStep,
  onAddSolicitudDemandaRes,
  onAddListUploaddedFiles,
  onShowModalVisor,
  onAddDocumentSelected,
  onSuccessMoveSolcitudToDemanda,
  onAllResetStateDemandas,
  onAddSolicitudDemandaSelected,
  onAddInitialActoresPartes,
  onAddInitialDemandadosPartes,
  onAddDocumentosListDemanda,
  onResetSelectsDemanda,
  onUpdateListSolicitudDemanda,
  onAddTipoModalidad, 
  onPermisoJuicios,
} = demandaSlice.actions;
